import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M12.4516 14.8014a.613.613 0 0 1-.9032 0l-4.3795-4.742C6.7979 9.6577 7.0782 9 7.6205 9h8.759c.5422 0 .8226.6577.4516 1.0594z"
}), "CaretDown", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
